import React from 'react';
import { MobileContainer as Container } from './style';
import { Icon } from '../../Components/Icons/Icons';
import { Text } from '../../UI/Text';
import { OuterMargin, Row, HoverableLink } from '../../Layouts';

export const MobileContainer = ({ itunesLink, description, header }) => {
    return (
        <Container>
            <Icon.Box size={'48x48'}>
                <Icon.Logo />
            </Icon.Box>
            <OuterMargin margin={'14px 0'}>
                <Text weight={'bold'} opacity={0.85}>
                    {header}
                </Text>
            </OuterMargin>
            <div style={{ width: '250px' }}>
                <OuterMargin bottom={'14px'}>
                    <Text fontSize={12} opacity={0.6} weight={200} lineHeight={1.5} center={true}>
                        {description}
                    </Text>
                </OuterMargin>
            </div>
            <Row>
                <HoverableLink
                    target={'_blank'}
                    to={{
                        pathname: itunesLink,
                    }}
                >
                    <Icon.Box size={'130x40'}>
                        <Icon.AppStoreLogo />
                    </Icon.Box>
                </HoverableLink>

                <HoverableLink
                    target={'_blank'}
                    to={{
                        pathname: 'https://play.google.com/store/apps/details?id=tona.workout.recording',
                    }}
                >
                    <Icon.Box size={'130x40'}>
                        <Icon.GooglePlayLogo />
                    </Icon.Box>
                </HoverableLink>
            </Row>
        </Container>
    );
};

MobileContainer.defaultProps = {
    itunesLink: 'https://itunes.apple.com/gb/app/tona-workout-recording/id1438739138?mt=8',
    description: 'Use it on your tablet or computer. Or download the App to start planning workouts...',
    header: 'Workout Planner',
};



// WEBPACK FOOTER //
// ./src/UI/Containers/WorkoutPlan/MobileContainer.js